import client from './client'

export const getLensShareLink = async payload => {
  try {
    const response = await client.post(`/shared`, payload)
    return response
  } catch (err) {
    console.error(err)
    const { response } = err

    if (response?.data && Object.keys(response.data).length > 0) return response.data

    return { error: err.message || err }
  }
}

export const getSharedLensDetail = async hash => {
  try {
    const response = await client.get(`/shared/${hash}`)
    return response
  } catch (err) {
    console.error(err)
    const { response } = err

    if (response?.data && Object.keys(response.data).length > 0) return response.data

    return { error: err.message || err }
  }
}
